import React from 'react'
import {  red, yellow, green } from '@mui/material/colors';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MoneyIcon from '@mui/icons-material/Money';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';


import { Contractor, Transaction, User, Patient, Physician } from '../../../../models';
import dayjs from 'dayjs';
import ContractorListWidget from '../contractors/contractor-list.component';
import Centered from '../../../../components/Centered';
import PatientListWidget from '../patients/patients-list.component';
import PhysicianListWidget from '../physicians/physician-list.component';
import { to2DecimalPlaces } from '../../../../helpers';



const TransactionView: React.FC<
    {
        transaction: Transaction;
        toPay?: User;
        initiatedBy: User;
    }
> = ({
    transaction, initiatedBy,
    toPay
}) => {
        const getColor = (): string => {
            let color: string;
            switch (transaction.Status) {
        
                case "Failed":
                    color = red[700];
                    break;
                case "Completed":
                    color = green[700];
                    break;
                default:
                    color = yellow[800]
                    break;
            }
            return color;

        }

     const getView = (model?: User) => {
         let ans = (<div />);
         if(!model) {
             return ans
         }
         switch (model.Role) {
            case "patient":
                ans = (<PatientListWidget patient={model as Patient} />);
                break;

                case "physician":
                    ans = <PhysicianListWidget physician={model as Physician} />
                    break;
         
             default:
                 ans = <ContractorListWidget contractor={model as Contractor} />
                 break;
         }
         return ans;
     }

        return (
            <Centered >

                <Paper style={{
                    padding: '1em',
                    borderRadius: '14px',
                    border: 'none',
                    width:'80%',

                    maxWidth: '450px',

                }} elevation={2} >
                  <List  sx={{ width: '100%', 
                  bgcolor: 'background.paper' }}>
                <ListItem>
                    <ListItemIcon>
                       <LocalOfferIcon /> 
                    </ListItemIcon>

                    <ListItemText primary="Paystack Reference" secondary={transaction.payStackReference || "No Reference"} />
                </ListItem>


                <ListItem>
                    <ListItemIcon>
                       <CalendarTodayIcon /> 
                    </ListItemIcon>

                    <ListItemText primary="Date" secondary={dayjs(transaction.createdAt).format("MMM D, YYYY")} />
                </ListItem>

                <ListItem>
                    <ListItemIcon>
                       <MoneyIcon /> 
                    </ListItemIcon>

                    <ListItemText primary="Amount" secondary={to2DecimalPlaces(transaction.Amount/100)} />
                </ListItem>

                <ListItem>
                    <ListItemIcon>
                       <CreditCardIcon /> 
                    </ListItemIcon>

                    <ListItemText primary="Paystack Fees" secondary={transaction.paystackFees} />
                </ListItem>

                <ListItem>
                    <ListItemIcon>
                       <CalendarViewDayIcon /> 
                    </ListItemIcon>

                    <ListItemText color={getColor()} primary="Type" secondary={transaction.TypeOfTransaction} />
                </ListItem>
                  </List>


                    <div style={{
                        margin: '1em 0'
                    }}>
                        <Typography fontWeight={'bold'}>
                            Initiated By
                        </Typography>
                        {getView(initiatedBy)}
                    </div>

           {toPay && (
                         <div style={{
                            margin: '1em 0'
                        }}>
                        <Typography fontWeight={'bold'}>
                            To Pay
                        </Typography>
                        {getView(toPay)}
                    </div>
           )}
                </Paper >
            </Centered>
        )
    }

export default TransactionView